import React, { useEffect, useState } from "react";
import MyInput from "../../MyComp/UI/form/MyInput";
import Status from "../../MyComp/UI/form/Status";
import MyButton from "../../MyComp/UI/form/MyButton";
import { useForm } from "react-hook-form";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PreviewAltCard,
  Row,
} from "../../components/Component";
import { Badge, Form } from "reactstrap";
import { createUnitAPI, listUnitAPI, updateUnitAPI } from "../../api/master/indes";
import { decrypt,   } from "../../utils/Utils";
import ConfirmModal from "../../MyComp/UI/modals/ConfirmModal";
import MyDataTable from "../../MyComp/UI/DataTable/MyDataTable";
import { toast } from "react-toastify";
import useLogout from "../../hooks/useLogout";

const Unit = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      data: [],
    },
  });
  const { logout } = useLogout();
  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState("Add");
  const isLoading = watch("isLoading");
  const data = watch("data");
  const [showModal, setShowModal] = useState(false);
  const [column, setColumn] = useState([
    {
      name: "Name",
      selector: (row) => row?.name,
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => (
        <div style={{ cursor: "pointer" }} onClick={() => handleToggleStatus(row)}>
          <Badge color={`${row.status ? "success" : "danger"}`}>{row.status ? "Active" : "InActive"}</Badge>
        </div>
      ),
      sortable: true,
      wrap: true,

      width: "220px",
    },
    {
      name: "Action",
      wrap: true,
      width: "220px",
      cell: (row) => (
        <div>
          <Button outline color={`warning`} size={`xs`} className={`me-1`} onClick={() => handleEdit(row)}>
            {" "}
            <Icon name="edit" />
          </Button>
          {/* <Button outline color={`danger`} size={`xs`} onClick={() => handleDelete(row)}>
              {" "}
              <Icon name="trash"></Icon>
            </Button> */}
        </div>
      ),
    },
  ]);
  useEffect(() => {
    getUnitList();
  }, []);
  const getUnitList = () => {
    listUnitAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status===true) {
          toast.success(res.data.message);
          toast.clearWaitingQueue();
          setValue("data", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status===false) {
          setValue("isLoading", false);
          setValue("data", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  const onFormSubmit = (data) => {
    const body = {
      name: watch("unit"),
      ...(mode == "Edit" && { status: watch("status")?.value }),
      ...(mode == "Edit" && { id: watch("selectedRow")?.id }),
    };
    if (mode == "Add") {
      createUnitAPI(body)
        .then((res) => {
          //const status = decrypt(res.data.status);
          if (res.data.status===true) {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            getUnitList();
            setIsOpen(false);
            setValue("isLoading", false);
          } else if (res.data.status===false) {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (res.data.status === "expired") {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setValue("isLoading", false);
          toast.error(err?.response?.data?.message);
        });
    }
    if (mode == "Edit") {
      updateUnitAPI(body)
        .then((res) => {
          //const status = decrypt(res.data.status);
          if (res.data.status===true) {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            getUnitList();
            setIsOpen(false);
            setValue("isLoading", false);
          } else if (res.data.status===false) {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (res.data.status === "expired") {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setValue("isLoading", false);
          toast.error(err?.response?.data?.message);
        });
    }
  };
  const handleEdit = (row) => {
    window.scrollTo(0, 0);
    setValue("selectedRow", row);
    setIsOpen(true);
    setMode("Edit");
    setValue("unit", row?.name);
    setValue("status", {
      label: row.status ? "Active" : "InActive",
      value: row.status,
    });
  };
  const handleToggleStatus = (row) => {
    setValue("selectedRow", row);
    setShowModal(true);
  };
  const confirmStatusChange = (data) => {
    const updatedStatus = watch("selectedRow").status === true ? false : true;
    setValue("isLoading", true);
    const formObject = {
      id: watch("selectedRow").id,
      status: updatedStatus,
    };
    updateUnitAPI(formObject)
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status===true) {
          toast.success(res.data.message);
          toast.clearWaitingQueue();
          getUnitList();
          setIsOpen(false);
          setValue("isLoading", false);
          setShowModal(false);
        } else if (res.data.status===false) {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  return (
    <>
      <Head title={"Units | Master"} />
      <Content>
        <BlockHead size={`sm`}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Manage Units"}
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="">
                <Button
                  color="primary"
                  outline
                  className={`  me-n1`}
                  onClick={() => {
                    setIsOpen((pre) => !pre);
                    setMode("Add");
                    reset();
                  }}
                >
                  <Icon name={isOpen ? "minus" : "plus"} />
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block> 
            {isOpen && (
              <PreviewAltCard>
                <Form onSubmit={handleSubmit(onFormSubmit)}>
                  <Row>
                    <Col md="2" className={``}>
                      <MyInput
                        register={register}
                        watch={watch}
                        setValue={setValue}
                        trigger={trigger}
                        errors={errors}
                        title={"Unit"}
                        name={"unit"}
                        placeholder={"Enter unit"}
                        required
                      />
                    </Col>
                     
                      <Col md={`2`}>
                        <Status
                        title={"Status"}
                          register={register}
                          watch={watch}
                          setValue={setValue}
                          trigger={trigger}
                          errors={errors}
                        />
                      </Col> 
                  </Row>
                  <Col md="2" className={``}>
                    <div className="form-group" style={{ marginTop: "31px" }}>
                      <MyButton isLoading={isLoading} mode={mode} />
                    </div>
                  </Col>
                </Form>
              </PreviewAltCard>
            )} 
          <MyDataTable data={data} columns={column} title={"Unit List"} isLoading={isLoading} />
        </Block>
      </Content>
      <ConfirmModal
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
        onConfirm={confirmStatusChange}
        status={watch("selectedRow")?.status}
      />
    </>
  );
};

export default Unit;
